import { SnackbarItem } from "components/snackbar/SnackbarList";
import { atom } from "recoil";

export const SnackbarListState = atom<Array<SnackbarItem>>({
    key: 'state.SnackbarList',
    default: []
});